import React, { useEffect } from 'react';
import { Box, Grid } from '@mui/material'
import SideMenu from '../sidemenu/SideMenu';
import { Outlet } from 'react-router-dom';
import Queue from '../player/queue/Queue';
import AddPlaylistDialog from '../dialog/AddPlaylistDialog';
import SubscribePopup from '../dialog/SubscribePopup';
import BottomMenu from '../sidemenu/BottomMenu';
import { useGetUserQuery } from '../../api/userApiSlice';
import WelcomePopup from '../dialog/WelcomePopup';


export function Main() {
    
    const {
        data: user
    } = useGetUserQuery({})

    useEffect(() => {
    })

    return <Box className="App" sx={{backgroundColor: '#FFFFFFEE', height: '100%', overflow: 'hidden'}}>
      <Grid container spacing={1} alignItems={'center'} sx={{backgroundColor: '#17043C', height: "100%", width: '100%', color: '#FFF', overflowY: 'hidden', borderRadius: '0px', p: 2, marginLeft: '0vh', position: 'relative'}}>
        { user ? <AddPlaylistDialog /> : '' }
        <SubscribePopup />
        <WelcomePopup />
        <Queue />
        <SideMenu user={user} />
        <Grid size={{ lg:10, md: 12, xs: 12}} sx={{height: {xs:'100%', md:'95%', lg:'100%'}, overflow: 'hidden', overflowY: 'scroll'}}><Outlet /></Grid>
        <BottomMenu user={user} />
      </Grid>
    </Box>
}
